import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const ApiIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25ZM9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75ZM6.21967 12.5303L7.28033 11.4697L4.81066 9L7.28033 6.53033L6.21967 5.46967L2.68934 9L6.21967 12.5303ZM10.7197 6.53033L11.7803 5.46967L15.3107 9L11.7803 12.5303L10.7197 11.4697L13.1893 9L10.7197 6.53033ZM7.5102 13.3767L8.9898 13.6233L10.4898 4.6233L9.0102 4.3767L7.5102 13.3767Z"
    />
  </SvgIcon>
);

export default ApiIcon;
